const localURL = "https://localhost:7232/";
const devURL = "https://teamsdmv-api-dev.musea2.azure.ext.gm.com/";
const testURL = "https://teamsdmv-api-tst.musea2.azure.ext.gm.com/";
const prodURL = "https://teamsdmv-api.musea2.azure.ext.gm.com/";

const preProdAuth = {
  auth_client_id: "0b8b43ad-7c0e-40cf-9031-bd2b6bb64a2b",
  auth_scope: "159d9257-3384-4992-a618-840d90db593c/.default",
  authority:
    "https://login.microsoftonline.com/6baa4eb1-106a-440b-b4f6-50134497d36d",
};

const prodAuth = {
  auth_client_id: "3c1edff1-d821-4005-81e0-36bb18a6c587",
  auth_scope: "4b9a009f-a1f0-42ae-b918-8ad09ae922a5/.default",
  authority:
    "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d",
};

const localEnv = { url: localURL, ...preProdAuth };
const devEnv = { url: devURL, ...preProdAuth };
const testEnv = { url: testURL, ...preProdAuth };
const prodEnv = { url: prodURL, ...prodAuth };

export const getEnv = () => {
  const url = window.location.origin;
  if (url.includes("local")) {
    return localEnv;
  }
  if (url.includes("dev")) {
    return devEnv;
  }
  if (url.includes("tst")) {
    return testEnv;
  }
  return prodEnv;
};
